import { DataBean } from "../DataBean";

export class WorkActivityNotes extends DataBean {

  public async getWorkActivityNotesCatalogPorPropiedades(properties: any, maxRows?: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "java.util.List_getWorkActivityNotesCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getWorkActivityNotesRender(page: number, maxRows: number, props: any): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "com.advantage.shared.Report_getWorkActivityNotesRender_Number_Number_java.util.Map",
      [page, maxRows, props]
    );
  }

  public async deleteWorkActivityNotes(idworkactivitynotes: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "boolean_deleteWorkActivityNotes_Number",
      [idworkactivitynotes]
    );
  }

  public async updateWorkActivityNotes(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "com.advantage.processflow.bean.WorkActivityNotes_updateWorkActivityNotes_com.advantage.processflow.bean.WorkActivityNotes",
      [
        {
          "DataBeanProperties": bean,
          "DataBeanName": "com.advantage.processflow.bean.WorkActivityNotes"
        }
      ]
    );
  }
}
